import React, {JSX} from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { buildLoginRedirect } from '../utils/detailRoute';
import { Box, Skeleton } from '@mui/material';
import { useAuth } from './AuthProvider';

interface PrivateRouteProps {
    children: JSX.Element;
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
    const { isAuthenticated, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <Box sx={{ px: { xs: 2, md: 4 }, py: { xs: 3, md: 5 } }}>
                <Skeleton variant="text" width={180} height={40} sx={{ mb: 3 }} />
                <Skeleton variant="rounded" height={56} sx={{ mb: 2 }} />
                <Skeleton variant="rounded" height={320} />
            </Box>
        );
    }

    if (isAuthenticated) {
        return children;
    }

    // Das angesteuerte Ziel inkl. Query im Login-Link mitfuehren, damit ein
    // Deep-Link aus einer Mail nach der Anmeldung nicht auf dem Dashboard endet.
    return <Navigate to={buildLoginRedirect(location.pathname, location.search)} replace />;
};

export default PrivateRoute;
